import $ from 'jquery';
const CLASSES = {
    open: 'open',
    selected: 'selected',
};

class Select {
    constructor(el) {
        this.el = el;
        this.inputEl = el.find('input');
        this.titleEl = el.find('.select__title');
        this.optionsEl = el.find('.select__options');
        this.value = null;
        this.titleEl.on('click', () => {
            this.toggle();
        });
        this.optionsEl.on('click', '.select__option', (e) => {
            const val = $(e.currentTarget).data('value');
            this.select(val);
            this.close();
            this.inputEl.closest('form').submit();
        });
    }
    select(value) {
        this.value = value;
        this.inputEl.val(value);
        const title = this.optionsEl.find('[data-value="' + value + '"]').html();
        this.setTitle(title);
        this.optionsEl.find('[data-value="' + value + '"]')
            .addClass(CLASSES.selected)
            .siblings().removeClass(CLASSES.selected);

    }
    setTitle(title) {
        this.titleEl.html(title);
    }
    toggle() {
        if (this.el.hasClass(CLASSES.open)) {
            this.close();
        }
        else {
            this.open();
        }
    }
    open() {
        this.el.addClass(CLASSES.open);
    }
    close() {
        this.el.removeClass(CLASSES.open);
    }
}

export default Select;